import { map, find, forEach } from 'lodash'
import { produce } from 'immer'
import assetUtil from '../utils/asset.util'
import { SubscriberData } from '../apis/subscriber.api'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'

export default {
  selectOptions (subscribers: SubscriberData[]) {
    return map(subscribers, subscriber => {
      const { name, id } = subscriber
      return { name, value: String(id) }
    })
  },

  tableHorizontalData (
    subscribers: SubscriberData[]
  ): TableHorizontalData<SubscriberData>[] {
    forEach(subscribers, (subscriber: TableHorizontalData<SubscriberData>) => {
      const actions: ActionName[] = ['edit']
      const action: ActionName = subscriber.isBlocked ? 'start' : 'resume'
      actions.push(action)
      subscriber.actions = actions
      if (subscriber.logo) {
        subscriber.logo = assetUtil.storageUrl(subscriber.logo)
      }
    })
    return subscribers
  },

  block (subscribers: TableHorizontalData<SubscriberData>[], id: number) {
    return produce(subscribers, subscribers => {
      const subscriber = find(subscribers, { id })
      if (!subscriber || !subscriber.actions) return
      subscriber.actions.splice(1, 1, 'start')
    })
  },

  unblock (subscribers: TableHorizontalData<SubscriberData>[], id: number) {
    return produce(subscribers, subscribers => {
      const subscriber = find(subscribers, { id })
      if (!subscriber || !subscriber.actions) return
      subscriber.actions.splice(1, 1, 'resume')
    })
  }
}
